<div [id]="menuCategoryId" *ngIf="(showMenuOptions && categoryHasOptions) || isMenuBlocked" class="menu-category">
    <div class="menu-category-container">
        <div class="container option-container flex-no-wrap flex-justify-start">
            <div *ngFor="let option of availableCategories; last as last">
                <div *ngIf="option.subMenus" class="full-width">
                    <app-menu-category-option [option]="option" [isLast]="last" [category]="category"
                        [initialIndex]="initialIndex" (showAllOptions)="onShowAllOptions($event)" (clickHideMenu)="onOpenMenu($event)"></app-menu-category-option>
                </div>
            </div>
        </div>
        <div class="fullMenuDivider">
            <mat-divider class="menu-category-divider"></mat-divider>
        </div>
        <div class="fullMenuContainer">
            <span class="icon-arrow-right"></span> <span [attr.tabindex]="initialIndex" [id]="menuCategoryFullMenuId" [ngClass]="{'second_element_to_target': true, 'full-menu': true}"
                (keydown.enter)="openFullMenu()" (focusout)="focusOut()" (click)="openFullMenu()">{{ 'fullMenuLink.TITLE' | translate }} {{ category.translationKey + ".TRANSLATION" | translate | uppercase }}
                {{ 'MenuLink.TITLE' | translate }}</span>
        </div>
    </div>
</div>
